module.exports = {
  methods: {
    exibeToast(flag, message) {
      var title = flag ? "Sucesso." : "Erro.";

      this.$bvModal.msgBoxOk(message, {
        bodyTextVariant: flag ? 'dark' : 'danger',
        headerTextVariant: flag ? 'dark' : 'danger',
        title: title,
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
      });
    },
  },
};
